import { render } from "./SystemBar.vue?vue&type=template&id=6e4bd1f7&scoped=true"
import script from "./SystemBar.vue?vue&type=script&lang=js"
export * from "./SystemBar.vue?vue&type=script&lang=js"

import "./SystemBar.vue?vue&type=style&index=0&id=6e4bd1f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4bd1f7"]])

export default __exports__